<template>
  <Page
    :step="step"
    :desktop="desktop"
    :title="title"
    :message="message"
    :inputs="totalInputs"
    :finished="touchedInputs"
  >

    <div class="radio-group">
      <div class="radio-group-child paypal">
        <label class="paypal">
          <input
            type="radio"
            class="radio"
            name="radio_button_1"
            value="paypal"
            v-model="picked"
          > Paypal
        </label>
      </div>
      <div class="radio-group-child">
        <label class="credit-card">
          <input
            type="radio"
            class="radio"
            name="radio_button_2"
            value="credit card"
            v-model="picked"
          > Credit Card
        </label>
      </div>
    </div>

    <transition
      name="fade"
      mode="out-in">
      <div
        class="payment-type"
        v-if="picked === 'paypal'"
        key="paypal"
      >
        <p>You will be taken to Paypal to authorise a payment.</p>
      </div>

      <div
        class="payment-type"
        v-else
        key="creditCard"
      >

        <div class="input-wrap">
          <label for="text_field">Card number</label>
          <input
            type="text"
            @keydown="incrementInput"
          >
        </div>

        <div class="input-wrap cvc">
          <label for="cvc">Security Code</label>
          <input
            type="text"
            @keydown="incrementInput"
          >
          <a
            class="help cvc"
            @click="toggleCVC"
          >What's this?</a>
          <transition name="fade">
            <div
              :style="{ display: cvcDisplayed }"
              v-if="cvcDisplayed === 'block'"
            >
              <p class="hint">
                The Security Code (or CVV) is an anti-fraud security feature to help verify that you are in possession of your credit / debit card. For Visa/Mastercard, the three-digit CVV number is printed on the signature panel on the back of the card immediately after the card's account number.
              </p>
              <img src="https://www.toucanbox.com/img/cvc.png">
            </div>
          </transition>
        </div>

        <div class="input-wrap expiry-wrap">
          <div class="expiry-child">
            <label for="expire-month">Expiry Month</label>
            <div class="select-wrapper">
              <select>
                <option
                  selected="selected"
                  disabled="disabled"
                  hidden="hidden"
                  value=""
                />
                <option>01</option>
                <option>02</option>
                <option>03</option>
                <option>04</option>
                <option>05</option>
                <option>06</option>
                <option>07</option>
                <option>08</option>
                <option>09</option>
                <option>10</option>
                <option>11</option>
                <option>12</option>
              </select>
            </div>
          </div>
          <div class="expiry-child">
            <label for="expire-year">Expiry Year</label>
            <div class="select-wrapper">
              <select
                @input="incrementInput"
              >
                <option
                  selected="selected"
                  disabled="disabled"
                  hidden="hidden"
                  value=""
                />
                <option>2018</option>
                <option>2019</option>
                <option>2020</option>
                <option>2021</option>
                <option>2022</option>
                <option>2023</option>
              </select>
            </div>
          </div>
        </div>

        <div class="input-wrap postcode">
          <label for="postcode">Postcode</label>
          <input
            type="text"
            @keydown="incrementInput"
          >
        </div>

      </div>
    </transition>

    <button
      class="success cta continue-button"
      @click="next">{{ picked === 'paypal' ? 'Go to Paypal' : 'Review order' }}<i class="fa fa-check"/></button>
  </Page>
</template>

<script>
import Page from '../library/page.vue'

export default {
  name: 'Payment',
  props: {
    step: {
      type: Number,
      default: 0
    },
    desktop: {
      type: Boolean,
      default: true
    },
    order: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Page
  },
  data () {
    return {
      title: 'Payment Details',
      message: 'Please add your payment method.',
      picked: 'paypal',
      cvcDisplayed: 'none',
      totalInputs: 4,
      touchedInputs: 0,
      inputTimer: null
    }
  },
  methods: {
    next: function (event) {
      if (this.picked === 'paypal') {
        this.$events.$emit('show-paypal', true)
      } else {
        this.$events.$emit('load-advance', true)
      }
    },
    incrementInput: function (event) {
      clearTimeout(this.inputTimer)
      this.inputTimer = setTimeout(() => {
        if (this.touchedInputs < this.totalInputs && !event.target.parentNode.classList.contains('valid')) {
          this.touchedInputs++
        }
        if (!event.target.parentNode.classList.contains('input-wrap')) {
          // parentNode three times? I recognise this isn't great...
          event.target.parentNode.parentNode.parentNode.classList.add('valid')
        } else {
          event.target.parentNode.classList.add('valid')
        }
      }, 250)
    },
    reviewOrder: function () {
      this.$events.$emit('review-order', 'payment-review')
    },
    toggleCVC: function () {
      this.cvcDisplayed = this.cvcDisplayed === 'none' ? 'block' : 'none'
    }
  }
}
</script>

<style lang="scss" scoped>
  // Page specific inline styles
  .hint {
    clear: both;
    padding-top: 10px;
  }

  .payment-type {
    margin-top: 1em;
  }

  .callout p {
    margin-bottom: 0;
  }

  @media only screen and (max-width: 440px) {
    .input-wrap.postcode input[type=text] {
        width: 6.5em;
    }
  }

  @media only screen and (min-width: 440px) {
    .input-wrap.postcode input[type=text] {
      float: none;
      margin: 0 0 20px 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/payment.vue